export enum MemberTypeEnum {
    USER = 'User',
    GROUP = 'Group'
}
